export default function getZoomAnimation (element, settings) {
    //Scale is in percentage in the editor/data, hence / 100
    return {
        opacity: 0,
        scale: settings.zoom / 100,
    }
}
